import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'

import { capitalize } from 'lodash'

import { convertDateTimeToPreferedTimezone } from 'data/dateTime/convertDateTimeToPreferedTimezone'
import { getInvoiceIsPartialStatusAndBucket } from 'utils/agingBucket'

import InvoiceStatusChip from 'components/common/chip/InvoiceStatusChip'
import { getActionLabel } from './postingActivityHelpers'

const PostingActivity = ({ version, previousVersion }) => {
  const { revType, updatedAt, status, dueDate, amountPaidCents, totalCents, createdAt, updatedByUser, createdBy } = version
  const previousStatus = previousVersion?.status

  const { onlyDate, onlyTime } = convertDateTimeToPreferedTimezone({ dateTime: updatedAt || createdAt })
  const formattedDateTime = [onlyDate, onlyTime].filter(Boolean).join(' ')

  const actionLabel = getActionLabel(status, previousStatus, revType)
  const actorUsername = updatedByUser?.username || createdBy
  const byUserText = actorUsername ? `by ${actorUsername} ` : ' '
  const modifiedByText = `${byUserText}@ ${formattedDateTime}`

  const formattedStatus = capitalize(status?.toLowerCase())
  const { isPartial } = getInvoiceIsPartialStatusAndBucket(formattedStatus, dueDate, amountPaidCents, totalCents)

  return (
    <Grid container spacing={2.5} alignItems="flex-start" wrap="nowrap" size={12}>
      <Grid minWidth={100} size="auto">
        <InvoiceStatusChip status={formattedStatus} isPartial={isPartial} />
      </Grid>
      <Grid size="grow">
        <Box>
          <Typography variant="h6" fontWeight={500}>
            {actionLabel}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {modifiedByText}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  )
}

PostingActivity.propTypes = {
  version: PropTypes.shape({
    revType: PropTypes.string,
    lastModifiedBy: PropTypes.string,
    updatedAt: PropTypes.string,
    status: PropTypes.string,
    dueDate: PropTypes.string,
    amountPaidCents: PropTypes.number,
    totalCents: PropTypes.number,
    feeCents: PropTypes.number,
    taxCents: PropTypes.number,
    postedAmountCents: PropTypes.number,
    serviceCount: PropTypes.number,
    woCount: PropTypes.number,
    updatedByUser: PropTypes.shape({
      username: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
    createdBy: PropTypes.string,
    createdAt: PropTypes.string,
  }).isRequired,
  previousVersion: PropTypes.shape({
    status: PropTypes.string,
  }),
}

export default PostingActivity
